import React, { useState } from 'react';
import MainLayout from '@/components/layout/MainLayout';
import { StatsCards } from '../components/StatsCards';
import { DashboardFiltersComponent } from '../components/DashboardFilters';
import { DashboardTabs } from '../components/DashboardTabs';
import type { DashboardFilters, DashboardTabType } from '../types/dashboard.types';

export const StatsDashboardPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<DashboardTabType>('categories');
  // Initialize with empty filters - statusId=1 is automatically applied in API
  const [filters, setFilters] = useState<DashboardFilters>({});

  const handleExportData = () => {
    // Placeholder for export functionality
    console.log('Exporting data with filters:', filters);
    // TODO: Implement export functionality
  };

  const handleGenerateChart = () => {
    // Placeholder for chart generation
    console.log('Generating chart with filters:', filters);
    // TODO: Implement chart generation
  };

  return (
    <MainLayout>
      <div className="space-y-6">
        {/* Header - Following AssignSample.tsx structure */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Dashboard de Alojamientos</h1>
            <p className="text-gray-600 mt-2">
              
            </p>
          </div>
        </div>

        {/* Statistics Cards */}
        <StatsCards filters={filters} />

        {/* Filters */}
        <DashboardFiltersComponent
          filters={filters}
          onFiltersChange={setFilters}
          onExportData={handleExportData}
          onGenerateChart={handleGenerateChart}
        />

        {/* Tabs with Data Tables */}
        <DashboardTabs
          filters={filters}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
      </div>
    </MainLayout>
  );
};